import { render, staticRenderFns } from "./CustomChart.vue?vue&type=template&id=3eab4584&scoped=true&"
import script from "./CustomChart.vue?vue&type=script&lang=js&"
export * from "./CustomChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomChart.vue?vue&type=style&index=0&id=3eab4584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eab4584",
  null
  
)

export default component.exports